import {useTranslation} from "react-i18next";
import Button from "@mui/material/Button";
import {Dialog} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import React from "react";
import {LessonFlat} from "@models/LessonFlat";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { UsedByContainer } from './RemoveFileDialog.styles';

export const RemoveFileDialog = (props: {onDelete: () => void, onClose: () => void, fileName: string, usedBy: LessonFlat[]}) => {
    const { t } = useTranslation();

    return (
        <Dialog
            open={true}
            onClose={props.onClose}
        >
            <DialogTitle>{t('nodeEditor.warning')}</DialogTitle>
            <DialogContent>
                <Typography>
                    {t("nodeEditor.areYouSureAboutFileRemove")} <b>{props.fileName}</b>?
                </Typography>
                <Typography>
                    {t("nodeEditor.followingTrainingsWillStopWorking")}
                </Typography>
                <UsedByContainer>
                    {props.usedBy.length > 0 ? (
                        <Box>
                            {props.usedBy.map((lessonFlat, index) => <Typography key={index}>- {lessonFlat.name}</Typography>)}
                        </Box>
                    ) : (
                        <Typography>{t("nodeEditor.noTrainingUsesThisFile")}</Typography>
                    )}
                </UsedByContainer>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} color="primary">
                    {t('nodeEditor.cancel')}
                </Button>
                <Button onClick={props.onDelete} color="error" autoFocus>
                    {t('nodeEditor.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}